module.exports = __webpack_public_path__ + "static/media/3.6d7a145d.jpg";